'use strict';

var lcgResponsive = require('../lcg_responsive'),
	util = require('../util'),
	linchpin = require('int_googletagmanager/linchpin/account');

/**
 * @function
 * @description switch button positions on mobile devices
 */
function fireReadyResize() {
	lcgResponsive.move(util.viewport.isMobile(), '.save-button', '.contact-button-mobile', '.contact-button-desktop');
}

exports.init = function () {
	$(document).ready(fireReadyResize);
	$(window).smartresize(fireReadyResize);

	$('.save-button').on('click', function (e) {
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.contactPreferencesEvent(e);
		}
	});
	// Click the unsubscribe from all button
	$('.unsubscribe-button').on('click', function (e) {
		e.preventDefault();
		// GTM Linchpin analytics
		if (SitePreferences.GTM_ENABLED) {
			linchpin.unsubscribeFromAllEvent(e);
		}
		// Uncheck all of the contact options
		$('.contact-preferences input').each(function () {
			if ($(this).prop('checked')) {
				$(this).trigger('click');
			}
		});
		$(this).prop('disabled', true);
	});
	// Enable save button if any checkboxes are clicked
	$('.contact-preferences input').on('click', function () {
		$('.save-button').prop('disabled', false);
	});
	var hasRedEyeError = $('.error.redeye').length > 0 ? true : false;
	// If a contact preference checkbox is clicked
	$('.send-me-attributes input').on('click', function () {
		if ($('.send-me-attributes input:checked').length > 0) {
			if (hasRedEyeError === false) {
				// Enable related to attributes
				$('.related-to-attributes .form-row').each(function () {
					$(this).removeClass('disabled');
					$(this).find('.checker').removeClass('disabled');
					$(this).find('input').prop('disabled', false);
				});
			}
			$('.unsubscribe-button').prop('disabled', false);
		} else {
			// Disable related to attributes
			$('.related-to-attributes .form-row').each(function () {
				$(this).addClass('disabled');
				$(this).find('.checker').addClass('disabled');
				$(this).find('input').prop('disabled', true);
				$(this).find('input').prop('checked', false).parent().removeClass('checked');
			});
			$('.unsubscribe-button').prop('disabled', true);
		}
	});
};
